export class MockActionsService {
  getActions(): any[] {
    return [];
  }
}

export const MockActionClientService = new MockActionsService();
